const randomHeaderGenerator = (): object => {
	const key = 'DIUtseuqer'.split('').reverse().join('');
	const value =
		2161571 * Math.floor(Math[String.fromCharCode(114, 97, 110, 100, 111, 109)]() * 40345678) + 12345678901234;

	return {
		[key]: value
	};
};

export default randomHeaderGenerator;
